import { Boxed } from "ngrx-forms";
import { AppRecord, IMany2One } from "./api.model";

export const COMPANY_MODEL = "res.company";

export interface ICompanyForm {
  company_id: Boxed<IMany2One>;
}

export class Company extends AppRecord {
  constructor(data: Partial<Company> = {}) {
    super(data);
  }
}
